<template>
    <div class="search-contents-wrap _category">

        <button type="button" class="mobile-back-btn" v-on:click="mobileSearchBack">
            <div class="md_icon-btn _small">
                <div class="inner"><SvgIconBack /></div>
            </div>
            <p>BACK</p>
        </button>

        <div class="scroll-inner">
            <div class="item-wrap search-contents-inner">

                <!--アパレル-->
                <div class="form_checkbox-wrap">

                    <!--lv1-->
                    <div class="item form_checkbox _all" v-for="(first_category,index) in $store.state.search.set.categories" v-bind:key="index">
                        <input type="checkbox" :name="'category-apparel-lv1' + (first_category.id)" class="" :id="'category-apparel' + (first_category.id)" v-on:change="changeFirstCategory(first_category)" checked="true" disabled>
                        <label :for="'category-apparel' + (first_category.id)" class="_highlight">
                            <div class="check-mark"><span></span></div>
                            <span>{{ first_category.name }}</span>
                        </label>

                        <div class="lv2-row">
                            <div class="form_checkbox-wrap _small">
                                <!--lv2-->
                                <div class="item form_checkbox _all">
                                    <input type="checkbox" :name="'category-apparel-lv2-all' + (first_category.id)" class="" :id="'category-apparel-lv2-all' + (first_category.id)" v-on:change="changeSecondCategoryALL(first_category)">
                                    <label :for="'category-apparel-lv2-all' + (first_category.id)">
                                        <div class="check-mark"><span></span></div>
                                        <span>ALL</span>
                                    </label>
                                </div><!--/.lv2-->

                                <!--lv2-->
                                <div class="item form_checkbox _all"  v-for="(second_category, second_category_index) in first_category.second_categories" v-bind:key="second_category_index">
                                    <input type="checkbox" :name="'category-apparel-lv2' + (second_category.first_category_id)" class="" :id="'category-apparel-lv2-mens' + (first_category.id) + '-lv2-' + ( second_category_index + 1)" v-on:change="changeSecondCategory(second_category)">
                                    <label :for="'category-apparel-lv2-mens' + (first_category.id) + '-lv2-' + ( second_category_index + 1)" class="_highlight">
                                        <div class="check-mark"><span></span></div>
                                        <span>{{ second_category.name }}</span>
                                    </label>

                                    <!--lv3-->
                                    <div class="lv2-row" v-if="second_category.first_category_id == 1 && second_category.id != 8">
                                        <div class="form_checkbox-wrap _small">
                                            <div class="item form_checkbox _all">
                                                <input type="checkbox" :name="'category-apparel-mens-lv3-all' + (second_category.id)" class="" :id="'category-apparel-mens-lv3-all' + (second_category.id)" v-on:change="changeThirdCategoryALL(second_category)">
                                                <label :for="'category-apparel-mens-lv3-all' + (second_category.id)">
                                                    <div class="check-mark"><span></span></div>
                                                    <span>ALL</span>
                                                </label>
                                            </div>
                                            <div class="item form_checkbox" v-for="(third_category,third_category_index) in second_category.third_categories" :key="third_category_index">
                                                <input type="checkbox" :name="'category-apparel-mens-lv3' + (third_category.second_category_id)" class="" :id="'category-apparel-mens-lv3-' + (third_category.id) + '-lv3-' + (third_category_index + 1)" v-on:change="changeThirdCategory(third_category)">
                                                <label :for="'category-apparel-mens-lv3-' + (third_category.id) + '-lv3-' + (third_category_index + 1)">
                                                    <div class="check-mark"><span></span></div>
                                                    <span>{{ third_category.name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div><!--/.lv3-->
                                </div><!--/.lv2-->
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div><!--/.search-contents-wrap._category-->
</template>


<script>

import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'

    export default {
        components: {
            //SvgIcon
            SvgIconBack,
            SvgIconSearch,
        },
        data() {
            return {
                searchCategoryLabelActive: 1,
            }
        },
        methods: {
            ////////////////////////////////////
            //検索メニューMobile表示Backボタン
            ////////////////////////////////////
            mobileSearchBack: function () {
                this.tabSelectorActive = '';
                for (const element of document.getElementsByName('search-select')) {
                    element.checked = false;
                }
            },
            changeFirstCategory(first_category) {
                var id = first_category.id;
                var name = 'input[name=category-apparel-lv2' + id +']';
                var name_all = 'input[name=category-apparel-lv2-all' + id +']';

                $(name).prop('checked', false);
                $(name_all).prop('checked', false);

                // 第一階層のチェックが外れた時にVuexの第三階層データとチェックを削除
                var first_category_id = first_category.id;
                var id = 'category-apparel' + first_category_id;
                var check = document.getElementById(id).checked;

                if (!check) {
                    if (first_category .id == 1) {
                        this.$store.state.search.form.categoriyLv3 = [];
                    }
                    for(var i in first_category.second_categories) {
                        var second_category = first_category.second_categories[i];
                        var name_lv3 = 'input[name=category-apparel-mens-lv3' + second_category.id +']';
                        $(name_lv3).prop('checked', false);
                        var name_lv3_all = 'input[name=category-apparel-mens-lv3-all' + second_category.id +']';
                        $(name_lv3_all).prop('checked', false);
                    }
                }

                // 第一階層のチェックが外れた時にVuexの第二階層データを削除
                var second_categories = this.$store.state.search.form.categoriyLv2;
                var result = second_categories.filter((second_category) => {
                    return (second_category.first_category_id !== first_category.id);
                });
                this.$store.state.search.form.categoriyLv2 = result;
            },
            changeSecondCategory(second_category) {
                var id = second_category.id;
                var name = 'input[name=category-apparel-mens-lv3' + id +']';
                var name_all = 'input[name=category-apparel-mens-lv3-all' + id +']';
                $(name).prop('checked', false);
                $(name_all).prop('checked', false);

                // 検索用の第二階層のデータをVuex格納
                var itemIndex = '';
                var itemCheck = true;

                this.$store.state.search.form.categoriyLv2.forEach(function(item, index){
                    if (item.name == second_category.name && item.first_category_id == second_category.first_category_id) {
                        itemIndex = index;
                        itemCheck = false;
                    }
                }); 

                if (!itemCheck){
                    this.$store.state.search.form.categoriyLv2.splice(itemIndex, 1)
                } else {
                    this.$store.state.search.form.categoriyLv2.push(second_category)
                }

                // 第二階層のチェックが外れた時にVuexの第三階層データを削除
                var third_categories = this.$store.state.search.form.categoriyLv3;
                if (third_categories) {
                    var result = third_categories.filter((third_category) => {
                        return (third_category.second_category_id !== second_category.id);
                    });
                }
                this.$store.state.search.form.categoriyLv3 = result;

                // 全選択のチェックを外す
                var first_category_id = second_category.first_category_id;
                var id = 'category-apparel-lv2-all' + first_category_id;
                var name = 'input[name=category-apparel-lv2-all' + first_category_id +']';
                var check = document.getElementById(id).checked;

                if (check) {
                    $(name).prop('checked', false);
                }
            },
            changeThirdCategory(third_category) {
                // 検索用の第三階層のデータをVuex格納
                var itemIndex = '';
                var itemCheck = true;

                if (this.$store.state.search.form.categoriyLv3){
                    this.$store.state.search.form.categoriyLv3.forEach(function(item, index){
                        if (item.name == third_category.name && item.second_category_id == third_category.second_category_id) {
                            itemIndex = index;
                            itemCheck = false;
                        }
                    }); 
                }

                if (!itemCheck){
                    this.$store.state.search.form.categoriyLv3.splice(itemIndex, 1)
                } else {
                    this.$store.state.search.form.categoriyLv3.push(third_category)
                }

                // 全選択のチェックを外す
                var second_category_id = third_category.second_category_id;
                var id = 'category-apparel-mens-lv3-all' + second_category_id;

                var check = document.getElementById(id).checked;

                var id = third_category.second_category_id;
                var name = 'input[name=category-apparel-mens-lv3-all' + id +']';

                if (check) {
                    $(name).prop('checked', false);
                }
                console.log('lv3',this.$store.state.search.form.categoriyLv3);
            },
            changeSecondCategoryALL(first_category) {
                var first_category_id = first_category.id;
                var id = 'category-apparel-lv2-all' + first_category_id;
                var check = document.getElementById(id).checked;
                var first_category_id = first_category_id;
                var name = 'input[name=category-apparel-lv2' + first_category_id +']';

                var arrayA = this.$store.state.search.form.categoriyLv2;
                var arrayB = first_category.second_categories;
                if (check) {
                    // 第二階層全て選択
                    this.$store.state.search.form.categoriyLv2 = [...new Set( [...arrayA, ...arrayB] )];
                    $(name).prop('checked', true);
                } else {
                    // 第二階層全て選択解除
                    this.$store.state.search.form.categoriyLv2 = arrayA.filter((second_category) => {
                        return (second_category.first_category_id !== first_category.id);
                    });

                    $(name).prop('checked', false);
                    for(var i in first_category.second_categories) {
                        var second_category = first_category.second_categories[i];
                        var name_lv3 = 'input[name=category-apparel-mens-lv3' + second_category.id +']';
                        $(name_lv3).prop('checked', false);
                        var name_lv3_all = 'input[name=category-apparel-mens-lv3-all' + second_category.id +']';
                        $(name_lv3_all).prop('checked', false);
                    }
                }
            },
            changeThirdCategoryALL(second_category) {
                var second_category_id = second_category.id;
                var id = 'category-apparel-mens-lv3-all' + second_category_id;
                var check = document.getElementById(id).checked;

                var name = 'input[name=category-apparel-mens-lv3' + second_category_id +']';
                var arrayA = this.$store.state.search.form.categoriyLv3;
                var arrayB = second_category.third_categories;
                if (check) {
                    // 第三階層全て選択
                    this.$store.state.search.form.categoriyLv3 = [...new Set( [...arrayA, ...arrayB] )];
                    $(name).prop('checked', true);
                } else {
                    // 第三階層全て選択解除
                    this.$store.state.search.form.categoriyLv3 = arrayA.filter((third_category) => {
                        return (third_category.second_category_id !== second_category.id);
                    });
                    $(name).prop('checked', false);
                }
            },
        }
    }
</script>
